import React from "react";
import { BadgeDollarSign, ShieldCheck, MousePointerClick, Clock3, TrendingUp } from "lucide-react";

const FEATURES = [
  {
    title: "No Upfront Costs",
    body: "The company allows everyone to start using EazyBot for FREE, then upgrade to a paid subscription once you're familiar with EazyBot's online portal and earning potential.",
    icon: BadgeDollarSign,
  },
  {
    title: "Trades 24/7/365",
    body: "The company's proven autopilot settings allow your digital employees to work around the clock, earning consistent income for you and your family.",
    icon: Clock3,
  },
  {
    title: "Non-Custodial",
    body: "You don't give your money to EazyBot and wait for them to pay you back. Your funds stay in your own crypto wallet that only YOU control, and you remain in control of your funds while EazyBot executes trades.",
    icon: ShieldCheck,
  },
  {
    title: "Easy to Use",
    body: "Your digital employees handle the labor that earns your income. Your job is to hire them and put them to work.",
    icon: MousePointerClick,
  },
  {
    title: "Compounds Your Profits",
    body: "EazyBot automatically reinvests the profits from your trades, allowing your trading balance to compound over time.",
    icon: TrendingUp,
  },
];

export const Pillars = () => {
  return (
    <section
      id="features"
      data-testid="pillars-section"
      style={{ background: "#F0F0FA" }}
      className="py-12 md:pt-[69.5px] md:pb-[59px] border-t border-b"
    >
      <div className="mx-auto max-w-5xl px-6 md:px-10">
        <div className="text-center mb-9">
          <div className="flex items-center justify-center gap-3">
          <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(13,71,161,0.7), transparent)" }} />
          <span
            className="font-mono-label section-eyebrow home-eyebrow"
            style={{ color: "#E8C97A", letterSpacing: "0.12em" }}
          >
            Why EazyBot
          </span>
          <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(13,71,161,0.7), transparent)" }} />
          </div>
          <h2 className="font-display key-features-heading mt-3" style={{ color: "#141034" }} data-testid="pillars-heading">
            Key Features
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm md:text-base leading-relaxed" style={{ color: "rgba(20,16,52,0.7)" }} data-testid="pillars-description">
            These key features separate EazyBot from any competitors.
          </p>
        </div>

        <div className="mx-auto flex max-w-[944px] flex-col gap-4">
          {FEATURES.map((feature) => (
            <FeatureRow key={feature.title} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

function FeatureRow({ title, body, icon: Icon }) {
  return (
    <div
      className="flex w-full items-center gap-5 rounded-xl px-5 py-5 md:gap-7 md:px-7 md:py-7"
      style={{ background: "rgba(255,255,255,0.62)", border: "1px solid rgba(13,71,161,0.2)", boxShadow: "0 4px 18px rgba(13,71,161,0.06)" }}
      data-testid={`feature-row-${title.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
    >
      <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full" style={{ background: "rgba(3,172,239,0.12)", color: "#0369A1" }} aria-hidden="true">
        <Icon className="h-7 w-7" />
      </span>
      <div className="min-w-0 flex-1">
        <h3 className="font-display text-base md:text-lg font-bold leading-snug" style={{ color: "#141034" }}>{title}</h3>
        <p className="mt-1.5 text-sm md:text-base leading-relaxed" style={{ color: "rgba(20,16,52,0.72)" }}>{body}</p>
      </div>
    </div>
  );
}
